import {
  productFamilyImageIdFormat,
  productImageIdFormat,
} from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const submitImageFeedback = {
  name: "submitImageFeedback" as const,
  input: z.object({
    imageId: z.union([
      productFamilyImageIdFormat.schema,
      productImageIdFormat.schema,
    ]),
    feedback: createEnum(["positive", "negative"]).nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
